import { render, staticRenderFns } from "./SalesTeams.vue?vue&type=template&id=0c93fd16&"
import script from "./SalesTeams.vue?vue&type=script&lang=js&"
export * from "./SalesTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports